/*
 * Service transitOrderInfo, replace event communication
 */
angular.module('posApp').factory('transitOrderInfo', () => {
  const transitOrderInfo = function (warehouseId, warehouseName, direction) {
    transitOrderInfo.warehouseId = warehouseId;
    transitOrderInfo.warehouseName = warehouseName;
    transitOrderInfo.direction = direction;
  };

  return transitOrderInfo;
});
